import { OidcConfiguration } from "@axa-fr/react-oidc";
import { APPLICATION } from "./constants";

const oidcConfiguration: OidcConfiguration = {
  client_id: "segurosauto-web",
  redirect_uri: `${window.location.origin}/authentication/callback`,
  scope: "openid profile email",
  authority: `https://auth.${
    APPLICATION.ENV !== "prd" ? `${APPLICATION.ENV}.` : ""
  }sicredi.io/auth/realms/person`,
  refresh_time_before_tokens_expiration_in_second: 120,
};

export default oidcConfiguration;
